import React, { useState } from 'react';
import clsx from 'clsx';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {
  Grid,
  Hidden,
  CardMedia,
  Typography,
} from '@material-ui/core';
import { HeartButton } from 'modules2/components';
// import ShareIcon from '@material-ui/icons/Share';

import radioImg from 'assets/images/radio200x200.jpg';

import Controls from '../components/Controls';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'black',
    width: '100%',
    zIndex: 1100,
    position: 'fixed',
    bottom: 0,
    display: 'flex',
    left: 0,
    height: 100,
  },
  icons: {
    fill: '#fff',
    height: 30,
    width: 30,
    paddingRight: 15,
    cursor: 'pointer',
  },
  lIcons: {
    fill: '#fff',
    height: 30,
    width: 30,
    background: theme.palette.pink,
  },
  ratingIcon: {
    fill: '#fff',
    height: 30,
    width: 30,
    cursor: 'pointer',
  },
  heartAction: {
    display: 'block',
    width: '2.8rem',
    marginTop: 20,
  },
  mediaWrapper: {
    marginTop: -50,
    width: 140,
    height: 140,
    display: 'inline-block',
    // position: 'absolute',
    border: '5px solid #C4C4C4',
    fontFamily: 'Arial',
    background: theme.palette.bodyColor,
    backgroundPosition: '0px -19px',
    backgroundSize: 203,
    backgroundPositionY: -19,
  },
  cardImage: {
    width: 140,
    height: 140,
    objectFit: 'cover',
  },
  details: {
    color: '#fff',
    fontFamily: 'Arial',
    marginLeft: 10,
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '50%',
  },
  radioTitle: {
    marginTop: 20,
    fontSize: 18,
    fontWeight: 'bold',
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  radioSubtitle: {
    fontSize: 16,
    color: '#CECECE',
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize',
  },
  defaultImageTitle: {
    top: -40,
    width: 135,
    fontSize: 13,
    color: '#fff',
    padding: '0 5px',
    position: 'absolute',
    display: 'block',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  defaultTitle: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
}));

export default function Playbar(props) {
  const classes = useStyles();
  const theme = useTheme();

  const {
    player,
    statevolum,
    handleVolume,
    audioStatus,
    toggleAudio,
    title,
    image,
    heartedStationIds,
    currentTime
  } = props;

  const [defaultImage, setDefaultImage] = useState(false);
  const isHearted = heartedStationIds
    ? heartedStationIds.some(
        (stationId) => stationId === props.station.stationuuid
      )
    : false;

  const onMediaFallback = (event) => {
    event.target.src = radioImg;
    setDefaultImage(true);
  };

  const onFavouriteClickHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    props.onFavouriteClick(props.station.stationuuid);
  };

  const style = {
    height: 40,
    width: 40,
    padding: 12,
    marginRight: -15,
    fill: theme.palette.pink,
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Hidden smDown>
          <Grid item md={4}></Grid>
        </Hidden>
        <Grid item sm={6} md={4}>
          <div style={{ display: 'flex' }}>
            <div className={classes.mediaWrapper}>
              <CardMedia
                alt="Image not available"
                component="img"
                className={classes.cardImage}
                src={image}
                onError={onMediaFallback}
              />
              {/*{defaultImage && (
                <div
                  className={clsx(
                    'defaultImageTitle',
                    classes.defaultImageTitle
                  )}
                >
                  <Grid className={classes.defaultTitle}>{title}</Grid>
                </div>
              )}*/}
            </div>
            <div className={classes.details}>
              <Typography className={classes.radioTitle}>{title}</Typography>
              <Typography className={classes.radioSubtitle}>
                {audioStatus}&nbsp;
                {props.state || props.country ? '|' : ''}&nbsp;
                {props.state ? props.state + ', ' : ''}&nbsp;
                {props.country}
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item sm={6} md={4} style={{display: 'flex'}}>
          <div className={classes.heartAction}>
            <HeartButton
                style={style}
                name={'Radio'}
                isHearted={isHearted}
                onFavouriteClickHandler={onFavouriteClickHandler}
            />
            {/*<IconButton aria-label="share">
                <ShareIcon />
              </IconButton>*/}
          </div>
          <Controls
            main
            player={player}
            statevolum={statevolum}
            handleVolume={handleVolume}
            toggleAudio={toggleAudio}
            status={audioStatus}
            currentTime={currentTime}
            {...props}
          />
        </Grid>
      </Grid>
    </div>
  );
}
